export default __webpack_public_path__ + "static/media/Standard_Content.e4dddbc6.svg";